/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap-requires.js');

// Optional Vendor Requires
// require('./vendor/waypoint');
// require('./vendor/waypoint-animate');

// App Requires
require('./app/intro-block');
require('./app/primary-navigation');
require('./app/feature-slider');
